import React from 'react';
import { Button } from 'components';

const TableTextAction = ({ children, ...props }) => (
	<Button lettercase='none' {...props}>
		{children}
	</Button>
);

export default TableTextAction;
